export const arizona = {
  "04000": "Arizona",
  "04001": "Apache County",
  "04003": "Cochise County",
  "04005": "Coconino County",
  "04007": "Gila County",
  "04009": "Graham County",
  "04011": "Greenlee County",
  "04012": "La Paz County",
  "04013": "Maricopa County",
  "04015": "Mohave County",
  "04017": "Navajo County",
  "04019": "Pima County",
  "04021": "Pinal County",
  "04023": "Santa Cruz County",
  "04025": "Yavapai County",
  "04027": "Yuma County",
};
